import { supabase } from '@/integrations/supabase/client';
import { CreateDistributionCenterPriceInput, DistributionCenterPrice, DistributionCenterPriceFilters } from '@/types/database/distribution-center-prices';

export const distributionCenterPriceService = {
  async getDistributionCenterPrices(filters?: DistributionCenterPriceFilters): Promise<DistributionCenterPrice[]> {
    let query = supabase
      .from('distribution_center_prices')
      .select('*')
      .order('created_at', { ascending: false });

    if (filters?.product_name) {
      query = query.eq('product_name', filters.product_name);
    }
    if (filters?.location) {
      query = query.ilike('location', `%${filters.location}%`);
    }
    if (filters?.date_from) {
      query = query.gte('date', filters.date_from);
    }
    if (filters?.date_to) {
      query = query.lte('date', filters.date_to);
    }

    const { data, error } = await query.limit(10000);

    if (error) throw error;
    return data || [];
  },

  async createDistributionCenterPrice(price: CreateDistributionCenterPriceInput): Promise<DistributionCenterPrice> {
    const { data: { user } } = await supabase.auth.getUser();
    
    const { data, error } = await supabase
      .from('distribution_center_prices')
      .insert({
        ...price,
        created_by: user?.id
      })
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async bulkCreateDistributionCenterPrices(prices: CreateDistributionCenterPriceInput[]): Promise<DistributionCenterPrice[]> {
    const { data: { user } } = await supabase.auth.getUser();
    
    const pricesWithUser = prices.map(price => ({
      ...price,
      created_by: user?.id
    }));

    const { data, error } = await supabase
      .from('distribution_center_prices')
      .insert(pricesWithUser)
      .select();

    if (error) throw error;
    return data || [];
  },

  async updateDistributionCenterPrice(id: string, price: Partial<CreateDistributionCenterPriceInput>): Promise<DistributionCenterPrice> {
    const { data, error } = await supabase
      .from('distribution_center_prices')
      .update(price)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async deleteDistributionCenterPrice(id: string): Promise<void> {
    const { error } = await supabase
      .from('distribution_center_prices')
      .delete()
      .eq('id', id);

    if (error) throw error;
  }
};
